<template>
  <div class="replay-console">
    <header class="console-header">
      <div class="brand-block">
        <span class="brand-code">WEMEET / POST EVENT</span>
        <h1>AI 视频工作台</h1>
        <p>选择正式内容，预检确认后生成会议回顾。</p>
      </div>
      <div class="meeting-block">
        <div>
          <span>会议名称</span>
          <strong>{{ meetingName || '未命名会议' }}</strong>
        </div>
        <div>
          <span>会议号</span>
          <strong class="meeting-code">{{ meetingCode || '—' }}</strong>
        </div>
      </div>
    </header>

    <div v-if="!meetingCode" class="missing-meeting">缺少 meetingCode，无法加载当前会议的视频生产任务。</div>

    <ReplayGenerationPanel v-else :meeting-code="meetingCode" />
  </div>
</template>

<script setup>
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import ReplayGenerationPanel from './components/meetingReplay/ReplayGenerationPanel.vue'
  const route = useRoute()
  const meetingCode = computed(() => String(route.query.meetingCode || '').trim())
  const meetingName = computed(() => String(route.query.meetingName || '').trim())
</script>

<style lang="scss" scoped>
  .replay-console {
    min-height: calc(100vh - 84px);
    padding: 20px;
    color: #303133;
    background: #f6f8f9;
  }

  .console-header {
    display: grid;
    grid-template-columns: minmax(0, 1.35fr) minmax(320px, 0.65fr);
    padding: 24px 28px;
    color: #303133;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    gap: 40px;
  }

  .brand-code {
    color: var(--el-color-primary, #1890ff);
    font-family: 'SFMono-Regular', Consolas, monospace;
    font-size: 11px;
    letter-spacing: 0.18em;
  }

  .brand-block {
    h1 {
      margin: 9px 0 8px;
      color: #303133;
      font-size: clamp(28px, 3vw, 38px);
      font-weight: 500;
      letter-spacing: -0.025em;
    }
    p {
      margin: 0;
      color: #909399;
      font-size: 14px;
    }
  }

  .meeting-block {
    display: grid;
    grid-template-columns: 1fr;
    align-self: stretch;
    background: #f5f7fa;
    border: 1px solid #ebeef5;
    border-radius: 6px;

    > div {
      display: flex;
      min-width: 0;
      padding: 18px;
      flex-direction: column;
      justify-content: center;
      gap: 8px;
      + div {
        border-top: 1px solid #e4e7ed;
      }
    }
    span {
      color: #909399;
      font-size: 11px;
    }
    strong {
      color: #303133;
      font-size: 14px;
      line-height: 1.5;
      overflow-wrap: anywhere;
      white-space: normal;
    }
    .meeting-code {
      font-family: 'SFMono-Regular', Consolas, monospace;
      font-size: 12px;
      word-break: break-all;
    }
  }

  .control-room {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 330px;
    min-height: 480px;
    margin-top: 16px;
    padding: 0;
    color: #303133;
    background: transparent;
    gap: 16px;
  }

  .network-banner,
  .missing-meeting {
    display: flex;
    padding: 12px 18px;
    align-items: center;
    justify-content: space-between;
    color: #8a5d12;
    background: #fff5df;
    border: 1px solid #f2d79f;
    font-size: 13px;

    button {
      padding: 5px 10px;
      color: #7c5310;
      background: transparent;
      border: 1px solid #ddb96e;
      border-radius: 6px;
      cursor: pointer;
    }
  }

  .missing-meeting {
    min-height: 180px;
    justify-content: center;
    color: #9a443f;
    background: #fff;
    border-color: #f0cbc8;
    border-radius: 8px;
  }

  @media (max-width: 1080px) {
    .console-header {
      grid-template-columns: 1fr;
    }
    .control-room {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 680px) {
    .replay-console {
      padding: 10px;
    }
    .console-header,
    .control-room {
      padding: 22px 18px;
    }
  }
</style>
